// removed by extract-text-webpack-plugin
module.exports = {"salePrice":"RelatedItemDiscount__salePrice__28dbf5da","netPrice":"RelatedItemDiscount__netPrice__28dbf5da"};


//////////////////
// WEBPACK FOOTER
// ./assets/js/newPdp/components/RelatedItemPrice/RelatedItemDiscount.scss
// module id = 3370
// module chunks = 7